/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_TotalInputs */

const zh_learn_total = /** @type {(inputs: Learn_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总数`)
};

const en_learn_total = /** @type {(inputs: Learn_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const es_learn_total = /** @type {(inputs: Learn_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Learn_TotalInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_total = /** @type {((inputs?: Learn_TotalInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_TotalInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_total(inputs)
	if (locale === "en") return en_learn_total(inputs)
	return es_learn_total(inputs)
});